<template>
  <div class="about">
    <mPageTitle
      :title="$t(page.title)"
      :description="$t(page.description)"
      :image="require('@/assets/images/webp/about.webp')"
    />
    <mAbout />
    <mDelivery />
  </div>
</template>
<script>
import mPageTitle from "../components/molecules/m-page-title.vue";
import mDelivery from "../components/molecules/about-us/m-delivery.vue";
import mAbout from "../components/molecules/about-us/m-about.vue";

const BASE_URL = "https://jeffbrasov.ro";

export default {
  metaInfo() {
    const lang = this.$i18n.locale;
    const pageUrl = `${BASE_URL}/${lang}/despre-noi`;
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": this.$t("Acasă"),
          "item": `${BASE_URL}/${lang}/`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": this.$t("Despre noi"),
          "item": pageUrl
        }
      ]
    };
    return {
      title: this.$t("seo_title_about"),
      meta: [
        { name: "description", content: this.$t("meta_desc_about") },
        { property: "og:title", content: `${this.$t("seo_title_about")} | Mr Jeff Brașov` },
        { property: "og:description", content: this.$t("meta_desc_about") },
        { property: "og:url", content: pageUrl },
        { name: "twitter:title", content: `${this.$t("seo_title_about")} | Mr Jeff Brașov` },
        { name: "twitter:description", content: this.$t("meta_desc_about") },
      ],
      link: [
        { rel: "canonical", href: pageUrl },
        { rel: "alternate", hreflang: "ro", href: `${BASE_URL}/ro/despre-noi` },
        { rel: "alternate", hreflang: "en", href: `${BASE_URL}/en/despre-noi` },
        { rel: "alternate", hreflang: "x-default", href: `${BASE_URL}/ro/despre-noi` },
      ],
      script: [
        { type: "application/ld+json", json: breadcrumbSchema }
      ],
    };
  },
  components: {
    mPageTitle,
    mDelivery,
    mAbout,
  },
  data() {
    return {
      page: {
        title: "Despre Noi",
        description:
          "La Mr Jeff, ne mândrim cu oferirea unor servicii de spălătorie de calitate superioară. Folosim detergenți premium și tehnologie avansată pentru a asigura rezultate impecabile de fiecare dată.",
      },
    };
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>
<style lang="scss" scoped>
.about {
  display: block;
}
</style>
